/** --------------------------------------------------------
* Author Tien Tran
* Email tientran0019@gmail.com
* Phone 0972970075
*
* Created: 2024-07-29 01:48:39

* Last updated on: 2024-07-29 01:48:39
* Last updated by: Tien Tran
*------------------------------------------------------- */

'use client';

import React from 'react';

import Image from 'next/image';

import { Stack, StackProps, Typography } from '@mui/material';

type PropTypes = StackProps & {
	title?: string | null;
	description?: string;
	descriptionSx?: StackProps['sx'];
};

const EmptyData: React.FC<PropTypes> = (props) => {
	const {
		title = 'Không có kết quả nào phù hợp',
		description = 'Chúng tôi không tìm thấy lựa chọn nào phù hợp với yêu cầu của bạn!  Hãy thử lại',
		descriptionSx,
		...other
	} = props;

	return (
		<Stack direction="column" alignItems="center" py={5} {...other}>
			<Image
				alt="empty"
				src={require('./images/empty.png')}
				width={120}
				height={0}
			/>
			<Typography variant="h6" mt={2} color="text.disabled" fontWeight="bold">
				{title}
			</Typography>
			<Typography variant="body2" mt={1} color="text.disabled" whiteSpace="pre-wrap" sx={{ ...descriptionSx }}>
				{description}
			</Typography>
		</Stack>
	);
};

export default EmptyData;
